import { render } from "./TelLink.vue?vue&type=template&id=40b76f5e&scoped=true"
import script from "./TelLink.vue?vue&type=script&lang=js"
export * from "./TelLink.vue?vue&type=script&lang=js"

import "./TelLink.vue?vue&type=style&index=0&id=40b76f5e&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b76f5e"]])

export default __exports__